import BlueProgressBar from "../../../common/BlueProgressBar";
import ImageCardDisplayElement from "./BuildingBlocks/ImageCardDisplayElement";
import ImageUploaderCardDisplay from "./BuildingBlocks/ImageUploaderCardDisplay";
import { useTranslation } from "react-i18next";
import "./UploadMainContent.css";

const UploadMainContent = ({
    uploadedTemplates,
    userSettings,
    setNameInput,
    nameInput,
    isButtonUploadGray,
    uploadTemplate,
    removeUploadedTemplateQuestion,
    isPublicUpload,
    setIsPublicUpload,
    selectUploadedTemplate,
    removeSelectedUploadedTemplateFromSelection,
    convertFile,
    uploadMessage,
    uploadFileData,
    selectedTemplates,
    removeSetImage,
    priceOptions,
    updateSelectedTemplate,
}) => {
    const { t } = useTranslation("templatesPage");

    let displayUploadProgressBar = <></>;

    if (uploadedTemplates.length >= 80) {
        displayUploadProgressBar = (
            <>
                <BlueProgressBar
                    selected={uploadedTemplates.length}
                    max={userSettings ? userSettings.uploadLimit : 1}
                    title={t("uploadPageMemesUploadedTitle")}
                />
                <br />
            </>
        );
    }

    return (
        <>
            <ImageUploaderCardDisplay
                convertFile={convertFile}
                nameInput={nameInput}
                isButtonUploadGray={isButtonUploadGray}
                uploadTemplate={uploadTemplate}
                setNameInput={setNameInput}
                uploadMessage={uploadMessage}
                uploadFileData={uploadFileData}
                removeSetImage={removeSetImage}
                isPublicUpload={isPublicUpload}
                setIsPublicUpload={setIsPublicUpload}
            />
            <br />
            <br />
            {displayUploadProgressBar}
            <BlueProgressBar
                selected={selectedTemplates.length}
                max={userSettings ? userSettings.storageLimit : 1}
                title={t("uploadPageSelectedMemesTitle")}
            />
            <br />
            <br />
            <div className="imageCardDisplayElementContainer">
                <ImageCardDisplayElement
                    uploadedTemplates={uploadedTemplates}
                    removeUploadedTemplateQuestion={
                        removeUploadedTemplateQuestion
                    }
                    selectUploadedTemplate={selectUploadedTemplate}
                    removeSelectedUploadedTemplateFromSelection={
                        removeSelectedUploadedTemplateFromSelection
                    }
                    selectedTemplates={selectedTemplates}
                    priceOptions={priceOptions}
                    updateSelectedTemplate={updateSelectedTemplate}
                />
            </div>
        </>
    );
};

export default UploadMainContent;
